/* eslint-disable compat/compat */

import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

import {
  FetchError,
  FetchType,
  Geografi,
  isGeografi,
  isParti,
  Parti,
  ValgResultat
} from '../../domain'
import { AppThunkAction } from '..'

export const fetchActions = createAsyncAction(
  'fylkesresultat/FETCH_REQUEST',
  'fylkesresultat/FETCH_SUCCESS',
  'fylkesresultat/FETCH_FAILURE'
)<FetchType, ValgResultat, FetchError>()

export const resetFylkesresultater = createAction('fylkesresultat/RESET', action => {
  return () => action()
})

async function fetchElectionData(grunndata: Geografi | Parti, api) {
  if (isGeografi(grunndata)) {
    return api.getValgdata(grunndata, 'fy')
  } else {
    return api.getPartivalgdata(grunndata, 'fy')
  }
}

export function fetchFylkesresutater(grunndata: Geografi | Parti): AppThunkAction {
  return async (dispatch, getState, api): Promise<void> => {
    await dispatch(fetchActions.request('LOAD'))
    try {
      const electionData = await fetchElectionData(grunndata, api)
      await dispatch(fetchActions.success(electionData))
    } catch (error) {
      await dispatch(fetchActions.failure({ error, grunndata }))
    }
  }
}

export function reloadFylkesresutater() {
  return async (dispatch, getState, api): Promise<void> => {
    const currentPage = getState().page.current
    if (!isGeografi(currentPage) && !isParti(currentPage)) {
      return
    }

    const isDataSaverEnabled = navigator['connection'] && navigator['connection'].saveData
    if (!navigator.onLine || isDataSaverEnabled) {
      return
    }

    await dispatch(fetchActions.request('RELOAD'))

    try {
      const electionData = await fetchElectionData(currentPage, api)
      await dispatch(fetchActions.success(electionData))
    } catch (error) {
      await dispatch(fetchActions.failure({ error, grunndata: currentPage }))
    }
  }
}

export type FylkesresultatAction =
  | ActionType<typeof fetchActions>
  | ActionType<typeof resetFylkesresultater>
